import { format, isAfter, isBefore, isSameDay, isSameMonth, startOfDay, } from 'date-fns';
import React from 'react';
import { twMerge } from 'tailwind-merge';
var Day = function (_a) {
    var day = _a.day, selectedDate = _a.selectedDate, maxDate = _a.maxDate, minDate = _a.minDate;
    return (React.createElement("div", { className: twMerge('w-8 h-8 text-center text-[#18142A99] text-body cursor-pointer rounded-full border border-transparent hover:bg-hover-grey hover:border-hover-grey grid content-center', selectedDate &&
            isSameDay(selectedDate, day) &&
            'bg-cerulean-20 font-semibold border border-cerulean-default', selectedDate && isSameMonth(day, selectedDate) && 'text-mirage', ((minDate && isBefore(startOfDay(day), startOfDay(minDate))) ||
            (maxDate && isAfter(startOfDay(day), startOfDay(maxDate)))) &&
            'text-alto pointer-events-none'), key: day.toLocaleString() }, format(day, 'd')));
};
export default Day;
